export enum RedirectType {
  Permanent = 301,
  Temporary = 302,
}
